import React from 'react';
import { useWatch } from 'react-hook-form';
import { RHTextField } from '../../../../../../../dum';
import { IOrderProduction } from '../../order-production-form';
import { useOrderProductionNamePrefix } from '../../order-production-name-prefix.context';
import { FIELD_LABELS, shortLabel } from '../../../../../../../../helpers';

const ARRAY_NAME: keyof IOrderProduction = 'order_production_products';
const KILOS_FIELD_NAME: keyof IOrderProduction['order_production_products'][number] =
    'kilos';
const GROUP_WEIGHT_FIELD_NAME: keyof IOrderProduction['order_production_products'][number] =
    'group_weight';

interface IKilosInputProps {
    index: number;
}

export function KilosInput({ index }: IKilosInputProps) {
    const prefix = useOrderProductionNamePrefix();
    const PREFIXED_ARRAY = `${prefix}${ARRAY_NAME}`;
    const INPUT_NAME = `${PREFIXED_ARRAY}.${index}.${KILOS_FIELD_NAME}`;
    const groupWeightValue = useWatch({
        name: `${PREFIXED_ARRAY}.${index}.${GROUP_WEIGHT_FIELD_NAME}`,
    });

    return (
        <RHTextField
            name={INPUT_NAME}
            label={shortLabel(FIELD_LABELS.kilos)}
            disableGutters
            disabled={!!groupWeightValue}
        />
    );
}
